import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';

export const useBookingAuth = (businessShortName: string) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleBookingClick = () => {
    if (!user) {
      // Redirect to login page with customer type and showReason parameter
      const redirectPath = `/${businessShortName}/booking`;
      navigate(`/login?type=customer&showReason=true&redirect=${encodeURIComponent(redirectPath)}`);
    } else {
      // User is logged in, proceed with booking
      navigate(`/${businessShortName}/booking`);
    }
  };

  const handleServiceBookingClick = (serviceId: string | number) => {
    if (!user) {
      // Redirect to login page with customer type and showReason parameter
      const redirectPath = `/${businessShortName}/booking${serviceId ? `?serviceId=${serviceId}` : ''}`;
      navigate(`/login?type=customer&showReason=true&redirect=${encodeURIComponent(redirectPath)}`);
    } else {
      // User is logged in, proceed with booking for specific service
      navigate(`/${businessShortName}/booking?serviceId=${serviceId}`);
    }
  };

  return { handleBookingClick, handleServiceBookingClick, isLoggedIn: !!user };
}; 